import { Outlet } from "react-router-dom";
import SidebarLayout from "../components/SidebarLayout";

const PagePrivate = () => {
  return (
    <SidebarLayout>
      <Outlet />
    </SidebarLayout>
  );
};

export default PagePrivate;
